/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserCouponCreateReqVo
 */
export interface UserCouponCreateReqVo {
    /**
     * 用户 ID，必传
     * @type {number}
     * @memberof UserCouponCreateReqVo
     */
    userId: number;
    /**
     * 优惠券名称，必传
     * @type {string}
     * @memberof UserCouponCreateReqVo
     */
    name: string;
    /**
     * 优惠券名称（韩文）
     * @type {string}
     * @memberof UserCouponCreateReqVo
     */
    nameKr?: string;
    /**
     * 有效期开始时间，格式：yyyy-MM-dd 或 yyyy-MM-dd HH:mm:ss
     * @type {string}
     * @memberof UserCouponCreateReqVo
     */
    beginTime?: string;
    /**
     * 有效期结束时间，格式：yyyy-MM-dd 或 yyyy-MM-dd HH:mm:ss
     * @type {string}
     * @memberof UserCouponCreateReqVo
     */
    endTime?: string;
    /**
     * 货币代码，如 CNY、USD、KRW 等，必传
     * @type {string}
     * @memberof UserCouponCreateReqVo
     */
    currencyCode: string;
    /**
     * 优惠券金额，字符串类型，支持小数，必传
     * @type {string}
     * @memberof UserCouponCreateReqVo
     */
    amount: string;
    /**
     * 是否可转让：0-不可转让，1-可转让，必传
     * @type {number}
     * @memberof UserCouponCreateReqVo
     */
    canTrans: number;
    /**
     * 优惠券作用于的附加服务 ID 列表，JSON 数组格式，如  [1,2,3,4] 可选
     * @type {Array<number>}
     * @memberof UserCouponCreateReqVo
     */
    additionalServiceIds?: Array<number>;
    /**
     * 适用账单类型列表
     * @type {Array<number>}
     * @memberof UserCouponCreateReqVo
     */
    billTypes?: Array<number>;
    /**
     * 最低账单金额
     * @type {number}
     * @memberof UserCouponCreateReqVo
     */
    minimumPrice?: number;
    /**
     * 优惠券发放数量，必须大于 0，必传
     * @type {number}
     * @memberof UserCouponCreateReqVo
     */
    number: number;
    /**
     * 优惠券来源：1-系统发放，2-其他用户转来，必传
     * @type {number}
     * @memberof UserCouponCreateReqVo
     */
    source: number;
    /**
     * 源用户 ID，当来源为 2（其他用户转来）时必填，可选
     * @type {number}
     * @memberof UserCouponCreateReqVo
     */
    sourceUserId?: number;
    /**
     * 是否可用：0-不可用，1-可用，默认可用，必传
     * @type {number}
     * @memberof UserCouponCreateReqVo
     */
    enable: number;
    /**
     * 发放方式 1 管理员发放，2 活动发放
     * @type {number}
     * @memberof UserCouponCreateReqVo
     */
    grantType: number;
    /**
     * 是否长期有效 0 否 1 是
     * @type {number}
     * @memberof UserCouponCreateReqVo
     */
    longTerm?: number;
    /**
     * 优惠券模板 ID，关联 coupon 表
     * @type {number}
     * @memberof UserCouponCreateReqVo
     */
    couponId?: number;
}

/**
 * Check if a given object implements the UserCouponCreateReqVo interface.
 */
export function instanceOfUserCouponCreateReqVo(value: object): value is UserCouponCreateReqVo {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('canTrans' in value) || value['canTrans'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('enable' in value) || value['enable'] === undefined) return false;
    if (!('grantType' in value) || value['grantType'] === undefined) return false;
    return true;
}

export function UserCouponCreateReqVoFromJSON(json: any): UserCouponCreateReqVo {
    return UserCouponCreateReqVoFromJSONTyped(json, false);
}

export function UserCouponCreateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserCouponCreateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'name': json['name'],
        'nameKr': json['nameKr'] == null ? undefined : json['nameKr'],
        'beginTime': json['beginTime'] == null ? undefined : json['beginTime'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'currencyCode': json['currencyCode'],
        'amount': json['amount'],
        'canTrans': json['canTrans'],
        'additionalServiceIds': json['additionalServiceIds'] == null ? undefined : json['additionalServiceIds'],
        'billTypes': json['billTypes'] == null ? undefined : json['billTypes'],
        'minimumPrice': json['minimumPrice'] == null ? undefined : json['minimumPrice'],
        'number': json['number'],
        'source': json['source'],
        'sourceUserId': json['sourceUserId'] == null ? undefined : json['sourceUserId'],
        'enable': json['enable'],
        'grantType': json['grantType'],
        'longTerm': json['longTerm'] == null ? undefined : json['longTerm'],
        'couponId': json['couponId'] == null ? undefined : json['couponId'],
    };
}

export function UserCouponCreateReqVoToJSON(json: any): UserCouponCreateReqVo {
    return UserCouponCreateReqVoToJSONTyped(json, false);
}

export function UserCouponCreateReqVoToJSONTyped(value?: UserCouponCreateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'name': value['name'],
        'nameKr': value['nameKr'],
        'beginTime': value['beginTime'],
        'endTime': value['endTime'],
        'currencyCode': value['currencyCode'],
        'amount': value['amount'],
        'canTrans': value['canTrans'],
        'additionalServiceIds': value['additionalServiceIds'],
        'billTypes': value['billTypes'],
        'minimumPrice': value['minimumPrice'],
        'number': value['number'],
        'source': value['source'],
        'sourceUserId': value['sourceUserId'],
        'enable': value['enable'],
        'grantType': value['grantType'],
        'longTerm': value['longTerm'],
        'couponId': value['couponId'],
    };
}

